export default [{
    path: "/peopleInvited",
    name: "peopleInvited",
    component: () => import("@simple/views/teacher/invited/invited.vue"),
}, {
    path: "/login",
    name: "login",
    component: () => import("@simple/views/teacher/login/login.vue"),
}, {
    path: "/protocal-user",
    name: "protocal-user",
    component: () => import("@simple/views/teacher/protocal/protocal-user.vue"),
}, {
    path: "/protocal-privacy",
    name: "protocal-privacy",
    component: () => import("@simple/views/teacher/protocal/protocal-privacy.vue"),
}, {
    path: "/parentLogin",
    name: "parentLogin",
    component: () => import("@simple/views/parent/login/login.vue"),
}, 
{
    path: "/faceLogin",
    name: "faceLogin",
    component: () => import("@simple/views/face/login.vue"),
}, 
{
    path: "/recruitsForm",
    name: "recruitsForm",
    component: () => import("@simple/views/parent/recruits-code/recruits-form.vue"),
},
{
    path: "/introducer",
    name: "introducer",
    component: () => import("@simple/views/teacher/introducer/introducer.vue"),
},
{
    path: "/contractDetail",
    name: "contractDetail",
    component: () => import("@simple/views/parent/contract/contract-detail.vue"),
},
//pc端学员详情-点评详情预览界面
{
    path: "/commentPreview/:id/:cid",
    name: "commentPreview",
    component: () => import("@simple/views/teacher/comment/comment-preview.vue"),
},
//pc端学员详情-成长记录预览界面
{
    path: "/growupPreview/:id/:cid/:uid",
    name: "growupPreview",
    component: () => import("@simple/views/teacher/growup/growup-preview.vue"),
},
//pc端学员详情-阶段测评预览界面
{
    path: "/evaluatePreview/:id/:cid/:uid",
    name: "evaluatePreview",
    component: () => import("@simple/views/teacher/evaluate/evaluate-preview.vue"),
},
{
    path: '/cepingPreview/:id/:cid/:uid',
    name: 'cepingPreview',
    component: () => import('@parent/views/base/ceping/detail.vue'),
}
];